module.exports = __webpack_public_path__ + "img/html5.b8a81da8.svg";